import Reveal from "@/components/base/Reveal";
import { migrationSteps } from "@/mocks/hospedagem";

export default function MigrationSteps() {
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <Reveal>
          <div className="mx-auto max-w-3xl text-center">
            <span className="inline-flex items-center gap-2 rounded-full bg-secondary-50 px-4 py-1.5 text-xs font-semibold uppercase tracking-wide text-secondary-700">
              <i className="ri-route-line" aria-hidden="true"></i>
              Migração
            </span>
            <h2 className="mt-5 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
              Traga o seu projeto para a NXHOST com tranquilidade.
            </h2>
            <p className="mt-4 text-base leading-relaxed text-foreground-600">
              Acompanhamos cada etapa da migração para que a transição seja simples e sem
              complicações.
            </p>
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {migrationSteps.map((step, index) => (
            <Reveal key={step.title} delay={index * 70} className="h-full">
              <article className="relative flex h-full flex-col rounded-xl border border-background-200 bg-background-50 p-6">
                <span className="absolute right-5 top-5 font-heading text-3xl font-bold text-background-200">
                  0{index + 1}
                </span>
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-100/70 text-primary-700">
                  <i className={`${step.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">
                  {step.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                  {step.description}
                </p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}